import React from 'react';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
import { withLocalize } from 'react-localize-redux';
import useArtifactContent from '../chatView/hooks/useArtifactContent';
import { ARTIFACT_PARAM, SESSION_PARAM, artifactContentUrl } from './artifactPageUrl';
import HtmlArtifactView from './HtmlArtifactView';
import css from './ArtifactPage.css';

const TRANSLATION_PREFIX = 'STATIC.PAGES.ARTIFACT_PAGE';

const ArtifactPage = ({ translate }) => {
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get(SESSION_PARAM);
    const artifactId = searchParams.get(ARTIFACT_PARAM);
    const contentUrl = sessionId && artifactId ? artifactContentUrl(sessionId, artifactId) : null;

    const { content, isLoading, error } = useArtifactContent(contentUrl);

    if (!contentUrl) {
        return (
            <div className={css.page}>
                <div className={css.state}>{translate(`${TRANSLATION_PREFIX}.MISSING_LINK`)}</div>
            </div>
        );
    }

    return (
        <div className={css.page}>
            <HtmlArtifactView content={content} isLoading={isLoading} error={error} />
        </div>
    );
};

ArtifactPage.propTypes = {
    translate: PropTypes.func.isRequired,
};

export default withLocalize(ArtifactPage);
